import React, {Fragment ,useState, useEffect} from 'react'
import AddOrEditEvent from "./AddOrEditEventForm";
import {connect} from 'react-redux' ;
import {Link, useParams} from 'react-router-dom' ;
import {getEvent} from "./actions";
import _ from 'lodash' ;
import {addEvent , editEvent} from "./actions";
import {withRouter} from 'react-router-dom' ;
import {reset} from 'redux-form' ;
import moment from "moment";
const AddEvent = (props) => {

    const {id} = useParams() ;
    const {eventInfo, postEventInfoResult} = props ;
    const [eventInitialValues, setEventInitialValues] = useState({}) ;
    const [renderForm, setRenderForm] = useState(false) ;
    const [loading, setLoading] = useState(false) ;
    const [postEventInfoResultMessage , setPostEventResultMessage] = useState(null) ;

    const onFormSubmit = (values) => {
        setLoading(true) ;
        let data = {
            name : values.name ,
            startDate : values.startDate.format("YYYY-MM-DD"),
            endDate : values.endDate.format("YYYY-MM-DD")
        };
        if (id === 'new') {
            props.addEvent(data) ;
        }
        else {
            data = {...data , id : Number(id)} ;
            props.editEvent(Number(id), data) ;
        }
    };

    const eventFormInitialValues = () => {
        if (id === 'new') {
            return {} ;
        }
        return _.isEmpty(eventInfo) ? {} : {
            name : eventInfo.name ,
            startDate : moment(eventInfo.startDate),
            endDate : moment(eventInfo.endDate)
        };
    };

    useEffect(() => {
        if (id !== 'new') {
            setRenderForm(false);
            props.getEvent(id) ;
        }
        else {
            props.reset("AddOrEditEvent") ;
        }
    } ,[id]);

    useEffect(() => {
        if (!_.isEmpty(eventInfo)) {
            setEventInitialValues(eventFormInitialValues()) ;
            setRenderForm(true) ;
        }
        else {
            setEventInitialValues({}) ;
        }
        if (id === 'new') {
            setRenderForm(true) ;
        }
    } , [eventInfo]);

    useEffect(() => {
        if (!_.isEmpty(postEventInfoResult)) {
            setLoading(false) ;
            if (postEventInfoResult.isSuccess) {
                if (id === 'new') {
                    props.history.push('/operators') ;
                }
                else {
                    setPostEventResultMessage({success : true , message : postEventInfoResult.message}) ;
                }
            }
            else{
                setPostEventResultMessage({success : false , message : postEventInfoResult.message}) ;
            }
        }
    } ,[postEventInfoResult]);

    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle ">
                    <div className="longTitle">
                        <Link to="/operators"><span className="back"><span
                            className="icon icon-arrow-right font-size_14"></span> بازگشت </span></Link>
                        <span className="separator"></span>
                        <span className=" font-size_24 boldFont middleContext">رویدادها</span>
                    </div>
                </div>
            </div>
            <span className="lineSeparator"></span>
            {renderForm ? <AddOrEditEvent onSubmit={onFormSubmit} initialValues={eventInitialValues} isAdd={id === 'new'} loading={loading}/> : null}
        </Fragment>
    );
};

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    return {
        eventInfo : id === 'new' ? null : state.eventsInfo[id],
        postEventInfoResult : state.postEventInfoResult
    };
};

export default withRouter(connect(mapStateToProps , {getEvent , editEvent , addEvent, reset})(AddEvent))